import { Flex, Form, Select, Space, Typography } from 'antd';

import { SearchButtons } from '@app/components';
import { PREFIX } from '@app/constants';
import { MONTHS, YEARS, DEFAULT_FILTERS_DATA } from '@app/pages/Analytics/data';
import { useReportEffects } from '@app/pages/Analytics/hooks';
import { useRevenueStatement } from '@app/pages/Analytics/RevenueStatement/hooks';
import { RevenueStatementTable } from '@app/pages/Analytics/RevenueStatement/ui/RevenueStatementTable';

import '@pages/Analytics/RevenueStatement/styles/RevenueStatement.desktop.scss';

const { Text } = Typography;
const { Item } = Form;

export const RevenueStatement = () => {
  const {
    handleReset,
    form,
    handleSubmitForm,
    handleSearchData,
    tableData,
    isLoading,
  } = useRevenueStatement();
  useReportEffects({
    handleSearchData,
  });

  return (
    <div className={`${PREFIX}revenue-statement`}>
      <Form
        form={form}
        onFinish={handleSubmitForm}
        initialValues={DEFAULT_FILTERS_DATA}
      >
        <Space
          className="content-header-space"
          direction="vertical"
          size="large"
        >
          <Flex justify="space-between">
            <Space size="large" align="baseline">
              <Text strong>Период:</Text>
              <Item name="filterMonth">
                <Select
                  placeholder="Выбор месяца"
                  popupMatchSelectWidth={false}
                  options={MONTHS}
                  className="filters-select"
                />
              </Item>
              <Item name="filterYear">
                <Select
                  placeholder="Выбор года"
                  popupMatchSelectWidth={false}
                  options={YEARS}
                  className="filters-select"
                />
              </Item>
            </Space>
            <SearchButtons
              className="desktop-buttons"
              resetAll={handleReset}
              showData={form.submit}
            />
          </Flex>

          <RevenueStatementTable isLoading={isLoading} tableData={tableData} />
        </Space>
      </Form>
    </div>
  );
};
